import type { UserPermission } from '@contracts/users/UserPermission';
import { dispatchInitializeExtensionMessage } from '@extJurAutofill/shared/InitializeExtensionMessage';
import { dispatchStorePermitMessage } from '@extJurAutofill/shared/StorePermitMessage';
import { AuthenticationStorage } from '@src/common/AuthenticationStorage';
import Config from '@src/config/Config';
import { buildStorePermitPayload } from '@src/extensionBridge/buildStorePermitPayload';
import type { PermitSummary } from '@src/orders/domain/PermitSummary';

export const initializeExtension = (args: {
  permit: PermitSummary;
  userPermissions: UserPermission[];
  language: string;
}) => {
  const accessToken = AuthenticationStorage.getAccessToken();

  if (accessToken) {
    dispatchInitializeExtensionMessage({
      apiUrl: Config.VITE_API_URL,
      accessToken,
      permissionsSet: args.userPermissions,
    });
  }

  dispatchStorePermitMessage(
    buildStorePermitPayload({ permit: args.permit, language: args.language }),
  );
};
